<template>
  <div class="survey__question" v-if="isActive">
    <div class="font-size-lg sm-font-size-xl text-center capped-md">
      {{ question.question }}
    </div>

    <div v-if="question.icon" class="survey__question-icon">
      <Icon :name="question.icon" />
    </div>

    <Component
      :is="question.type"
      :question="question"
      :answers="question.answers"
    />
  </div>
</template>

<script>
import Icon from '@/survey/components/Icon.vue';
import MultipleChoice from '@/survey/components/MultipleChoice.vue';
import OpenQuestion from '@/survey/components/OpenQuestion.vue';

export default {
  components: {
    Icon,
    MultipleChoice,
    OpenQuestion,
  },

  props: {
    question: {
      type: Object,
      required: true,
    },

    isActive: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
};
</script>
